import { LOAD_NAMED_PARTY_RESULTS_SUCCESS } from '../types';

const resetResults = () => {
  return {
    type: LOAD_NAMED_PARTY_RESULTS_SUCCESS,
    payload: {
      isFetchingResults: false,
      count: 0,
      results: [],
    },
  };
};

export default () => {
  return async dispatch => {
    await dispatch(resetResults());
  };
};
